<template>
    <LayoutFullPage :backLink="URL_SETTINGS_PAGES">
        <div class="typographies-display-medium enable-conformity__title">
            {{ $t.__('settings.sellsymodule.invoicing.enable_conformity.title') }}
        </div>
        <div class="typographies-paragraph-medium-regular enable-conformity__explanation">
            {{ $t.__('settings.sellsymodule.invoicing.enable_conformity.explanation') }}
        </div>
        <div class="enable-conformity__rules">
            <div class="typographies-heading-h4 enable-conformity__rules--title">
                {{ $t.__('settings.sellsymodule.invoicing.enable_conformity.rules_title') }}
            </div>

            <div class="enable-conformity__rules-list">
                <div
                    v-for="(ruleText, index) in conformRuleText"
                    :key="index"
                    class="typographies-paragraph-medium-regular enable-conformity__rules-list-item"
                >
                    <CompassIcon icon="success-circle-fill" type="success" />
                    {{ ruleText }}
                </div>
            </div>
            <CompassCheckbox
                :modelValue="
                    $t.__('settings.sellsymodule.invoicing.enable_conformity.checkbox_rules')
                "
                @change="(value) => (rulesChecked = value)"
            />
        </div>
        <CompassAlert
            type="warning"
            :description="$t.__('settings.sellsymodule.invoicing.enable_conformity.alert_text')"
            :showClose="false"
            class="enable-conformity__alert"
        />
        <CompassCheckbox
            :modelValue="
                $t.__(
                    'settings.sellsymodule.invoicing.enable_conformity.checkbox_acknowledge_changes',
                )
            "
            class="enable-conformity__acknowledge-changes"
            @change="(value) => (acknowledgeChangesChecked = value)"
        />
        <div class="enable-conformity__actions">
            <CompassButton
                type="secondary"
                :label="$t.__('common.actions.cancel')"
                @click="returnToSettingsPages"
            />
            <CompassButton
                :loading="confirmationPending"
                :disabled="!acknowledgeChangesChecked || !rulesChecked"
                :label="$t.__('settings.sellsymodule.invoicing.enable_conformity.confirm_button')"
                @click="handleConfirm"
            />
        </div>
    </LayoutFullPage>
</template>

<script>
const URL_SETTINGS_PAGES = '/documents/preferences/conformity';

import LayoutFullPage from 'vcomponents/layouts/LayoutFullPage.vue';
import { activateConformity } from 'api/settings/invoicing/conformity/ConformityService';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapStateSystem } = createNamespacedHelpers('system');

export default {
    components: { LayoutFullPage },
    data() {
        return {
            URL_SETTINGS_PAGES,
            conformRuleText: [
                this.$t.__(
                    'settings.sellsymodule.invoicing.conformity.is_conform_credit_note_creation',
                ),
                this.$t.__('settings.sellsymodule.invoicing.conformity.is_conform_invoice_number'),
                this.$t.__('settings.sellsymodule.invoicing.conformity.is_conform_invoice_date'),
            ],
            rulesChecked: false,
            acknowledgeChangesChecked: false,
            confirmationPending: false,
        };
    },
    computed: {
        ...mapStateSystem(['errorsHandler']),
    },
    methods: {
        async handleConfirm() {
            try {
                this.confirmationPending = true;
                await activateConformity();
                window.location.href = `${URL_SETTINGS_PAGES}?success`;
            } catch (error) {
                this.errorsHandler.logException(error);
                this.$pushToast({
                    type: 'error',
                    icon: true,
                    text: this.$t.__(
                        'settings.sellsymodule.invoicing.enable_conformity.error_conformity_activation',
                    ),
                });
            } finally {
                this.confirmationPending = false;
            }
        },
        returnToSettingsPages() {
            window.location.href = URL_SETTINGS_PAGES;
        },
    },
};
</script>

<style lang="scss" scoped>
.enable-conformity {
    &__title {
        margin-bottom: var(--spacing-6);
    }

    &__explanation {
        margin-bottom: var(--spacing-3);
    }

    &__rules {
        border: 1px solid var(--colors-common-border-default);
        border-radius: var(--spacing-0);
        margin-bottom: var(--spacing-3);
        padding: var(--spacing-3);

        &--title {
            margin-bottom: var(--spacing-1);
        }

        &-list {
            display: flex;
            flex-direction: column;
            gap: var(--spacing-1);
            margin-bottom: var(--spacing-4);

            &-item {
                display: flex;
                gap: var(--spacing-0);
            }
        }
    }

    &__acknowledge-changes {
        margin-bottom: var(--spacing-6);
    }

    &__actions {
        display: flex;
        gap: var(--spacing-3);
        justify-content: flex-end;
    }

    &__alert {
        margin-bottom: var(--spacing-6);
    }
}
</style>
